const DetailPanel = () => {
  return <p>outgoingInvoice detail panel </p>
}

export default DetailPanel
